import {UserPublic} from "@alpha-nft/marketplace-models";
import {marketplaceServerUrl} from "../lib/utils";

export async function fetchUserPublic(pubkey: string): Promise<UserPublic> {
  return (await fetch(`${marketplaceServerUrl()}/users/${pubkey}`)).json();
}